// extracted by mini-css-extract-plugin
export var heroImage = "_kh-1";
export var modal = "_kh-0";